import {
    UPDATE_GPS_LOCATION,
  } from "../store/types";
  
  const INITIAL_STATE = {
    location: null,
    error: false
  }
export const gpsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_GPS_LOCATION:
            if (action.payload && action.payload.lat) {
                // Position valide → pas d'erreur
                return { location: action.payload, error: false };
            } else if (action.payload && action.payload.error === true) {
                // Erreur explicite → on efface la position
                return { location: null, error: true };
            } else {
                // Dispatch sans lat et sans error:true (ex: hors service) → on efface juste l'erreur
                return { location: null, error: false };
            }
        default:
            return state;
    }
};